import { Component, OnInit, Inject, HostListener } from "@angular/core";
import { ManikEntityService } from "../manik-library/ManikEntityService";
import { Title } from "@angular/platform-browser";
import { ManikHeaders } from "../manik-library/manik-header.service";
import { ManikEntityFE } from "../manik-library/ManikEntityFE";
import { DOCUMENT } from "@angular/common";
import { HttpHeaders } from "@angular/common/http";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  public DomainName: string;
  public EndPoint: string = "";
  IsPortalInitialized: boolean = false;
  constructor(
    public _manikEntityService: ManikEntityService,
    @Inject(DOCUMENT) public document: any,
    private title: Title,
    private _header: ManikHeaders
  ) {
    this.DomainName = location.hostname.replace("www.", "");
    this.EndPoint = "https://entityserver.manikworks.com/";
  }

  ngOnInit() {
    if (this.DomainName === "emcity.ae") {
      this.SetPortalIdentifierAndApplyTheme(
        "EMCITY",
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/emcity/emcityportal.css?vvvv"
      );
    } else if (this.DomainName === "instasme.com") {
      this.SetPortalIdentifierAndApplyTheme(
        "DEMOCITY",
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/demociti/democitiportal.css"
      );
    } else if (this.DomainName === "urbanbizcoin.com") {
      this.SetPortalIdentifierAndApplyTheme(
        "DEVCITY", // "http://demohtml.maniklab.com/mall-temp/files/style.css");
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/devcitiportal/devcitiportal.css"
      );
    } else if (
      this.DomainName === "now.instaciti.com" ||
      this.DomainName === "instaciti.com"
    ) {
      if (document.location.pathname.includes("bizspot")) {
        this.SetPortalIdentifierAndApplyTheme(
          "INSTACITI",
          "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/bizspot.css"
        );
      } else {
        this.SetPortalIdentifierAndApplyTheme(
          "INSTACITI",
          "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instacitiportal.css"
        );
      }
    } else if (this.DomainName === "bizspot.instaciti.com") {
      this.SetPortalIdentifierAndApplyTheme(
        "INSTACITI",
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/bizspot.css"
      );
    } else if (this.DomainName === "live.instaciti.com" || this.DomainName == 'live.famous.one' || this.DomainName == 'automobiles.instaciti.com' || this.DomainName == "realestate.instaciti.com") {
      this.SetPortalIdentifierAndApplyTheme(
        "INSTACITI",
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-now.css"
      );
    } else if (this.DomainName === "market.instaciti.com") {
      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/portal/marketplace/theme/theme-two/instaciti-marketplace.css"
      // );
      this.SetPortalIdentifierAndApplyTheme(
        "INSTACITI",
        "https://dkzxkcjlbnjui.cloudfront.net/portal/marketplace/theme/theme-two/instaciti-marketplace.css"
      );  
      this.SetPortalIdentifierAndApplyTheme(
        "INSTACITI",
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-marketplace-master.css"
      );
      // this.SetPortalIdentifierAndApplyTheme("INSTACITI", "https://dkzxkcjlbnjui.cloudfront.net/portal/marketplace/theme/theme-three/instaciti-marketplace.css");
 


    } else if (this.DomainName == "localhost") {
      // this.SetPortalIdentifierAndApplyTheme("INSTACITI", "https://dkzxkcjlbnjui.cloudfront.net/portal/marketplace/theme/theme-three/instaciti-marketplace.css");
      this.SetPortalIdentifierAndApplyTheme(
        "INSTACITI",
        // "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-now.css"
                "https://dkzxkcjlbnjui.cloudfront.net/portal/marketplace/theme/theme-two/instaciti-marketplace.css"

      );
      this.SetPortalIdentifierAndApplyTheme(
        "INSTACITI",
        "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-marketplace-master.css"
      );
      // this.SetPortalIdentifierAndApplyTheme("EMCITY", "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/emcity/emcityportal.css?vvvv");
      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instacitiportal.css"
      // );
      

      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/portal/marketplace/theme/theme-two/instaciti-marketplace.css"
      // );
      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-marketplace-master.css"
      // );
      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/bizspot.css"
      // );
      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-now.css"
      // );
      // this.SetPortalIdentifierAndApplyTheme(
      //   "INSTACITI",
      //   "https://dkzxkcjlbnjui.cloudfront.net/developer/portal/instaciti/instaciti-mall.css"
      // );
    }

    //     let body: any =     {
    //       "Email": "manikidentityadmin@manikworld.com",
    //       "Password": "ManikIdentityAdmin@2018"
    //   };

    // body = JSON.stringify({ 'items': [body] });

    // const newheaders = new HttpHeaders({
    // 'PortalContext':'EMCITY',
    // 'Operation':'jwt/token'
    // });

    // this._manikEntityService.manikWebAPIConnectHttp("https://secureaccess.manikworks.com/membergateway", body,
    // { headers: newheaders })
    // .subscribe((data) => {
    //       sessionStorage.setItem('ManikAuthToken', data['ManikJSon'][0].JSon0);
    //       sessionStorage.setItem('sToken', data['ManikJSon'][0].JSon0);
    //       console.log(this.DomainName)

    //       sessionStorage.setItem("PortalDS", "");
    //       setTimeout(() => {
    //         this.api_CheckVersionUpdate();
    //       }, 200);

    //   },
    //     error => {

    //     });

    const newheaders = new HttpHeaders({
      TenantID: "INSTA.WEB",
    });

    this._manikEntityService
      .manikWebAPIConnectGeneric(
        "https://entityserver.manikworks.com/apptoken",
        null,
        newheaders,
        "GET"
      )
      .subscribe(
        (data) => {
          sessionStorage.setItem("ManikAuthToken", data["ManikJSon"][0].JSon0);
          sessionStorage.setItem("sToken", data["ManikJSon"][0].JSon0);
          console.log(this.DomainName);

          sessionStorage.setItem("PortalDS", "");

          this.api_CheckVersionUpdate();
        },
        (error) => {}
      );
  }

  api_CheckVersionUpdate(): void {
    this._header.updateFilterParams(sessionStorage.getItem("PortalIdentifier"));
    this._manikEntityService
      .manikEntityConnect2(
        this.EndPoint + "entitymgr",
        null,
        this._header.prepareAddlQueryHeaders2(
          "SEMI.QUICK",
          "APP.GET.VERSION",
          "APP"
        )
      )
      .subscribe((data) => {
        if (
          localStorage.getItem(this.DomainName + "_AppCurrentVersion") !==
          data.ManikJSon[0].JSon0[0].CurrentVersionNo
        ) {
          localStorage.clear();
          localStorage.setItem(
            this.DomainName + "_AppCurrentVersion",
            data.ManikJSon[0].JSon0[0].CurrentVersionNo
          );
          this.api_InitializeAppMetaData();
        } else {
          this.IsPortalInitialized = true;
          sessionStorage.setItem("IsPortalInitialize", "Y");
          if (!sessionStorage.getItem("PortalDS")) {
            let ManikUserContext = JSON.parse(
              localStorage.getItem(this.DomainName + "_ManikUserContext")
            );
            let PortalDS = "";
            if (ManikUserContext.CountryID) {
              PortalDS = JSON.parse(
                localStorage.getItem(this.DomainName + "_ManikCountry")
              ).find(
                (item) => item.CountryID === ManikUserContext.CountryID
              ).CountryDBContext;
            } else {
              PortalDS = JSON.parse(
                localStorage.getItem(this.DomainName + "_ManikMetaData")
              ).find(
                (item) => item.CountryID === ManikUserContext.CountryID
              ).CountryDBContext;
            }
            sessionStorage.setItem("PortalDS", PortalDS);
            // sessionStorage.setItem("PortalDS", 'EMCITY');
          }
        }
      });
  }

  api_InitializeAppMetaData(): void {
    this._header.updateFilterParams(sessionStorage.getItem("PortalIdentifier"));
    this._manikEntityService
      .manikEntityConnect2(
        this.EndPoint + "entitymgr",
        null,
        this._header.prepareAddlQueryHeaders2(
          "SEMI.QUICK",
          "APP.META.DATA",
          "APP"
        )
      )
      .subscribe((data) => {
        this.api_InitializeAppMasterMetaData();
        let resp: any = data.ManikJSon[0].JSon0;
        if (resp.length) {
          resp.forEach((item) => {
            let arr: any;
            switch (item.EntityIndex) {
              case "JSon1":
                arr = data.ManikJSon[0].JSon1[0];
                // console.log(sessionStorage.getItem("favIcon"))
                // sessionStorage.getItem("favIcon")?'':sessionStorage.setItem("favIcon",  data.ManikJSon[0].JSon1[0].FaviconURL);
                // this.document.getElementById("favIcon").setAttribute('href', sessionStorage.getItem("favIcon"));

                // this.document.getElementById("favIcon").setAttribute('href', data.ManikJSon[0].JSon1[0].FaviconURL);

                this.title.setTitle(data.ManikJSon[0].JSon1[0].Title);
                if (!sessionStorage.getItem("PortalDS"))
                  sessionStorage.setItem("PortalDS", arr.CountryDBContext);
                // sessionStorage.setItem("PortalDS", 'EMCITY');
                break;
              case "JSon2":
                arr = data.ManikJSon[0].JSon2[0];
                break;
              case "JSon3":
                arr = data.ManikJSon[0].JSon3[0];
                break;
            }
            console.log(arr);
            localStorage.setItem(
              this.DomainName + "_" + item.Entity,
              JSON.stringify(arr)
            );
          });
        }
        this.IsPortalInitialized = true;
        sessionStorage.setItem("IsPortalInitialize", "Y");
      });
  }

  public api_InitializeAppMasterMetaData(): void {
    this._header.updateFilterParams(sessionStorage.getItem("PortalIdentifier"));
    this._manikEntityService
      .manikEntityConnect2(
        this.EndPoint + "entitymgr",
        null,
        this._header.prepareAddlQueryHeaders2(
          "SEMI.QUICK",
          "APP.MASTER.DATA",
          "APP"
        )
      )
      .subscribe((data) => {
        let resp: any = data.ManikJSon[0].JSon0;
        if (resp.length) {
          resp.forEach((item) => {
            let arr: any;
            switch (item.EntityIndex) {
              case "JSon1":
                arr = data.ManikJSon[0].JSon1;
                break;
              case "JSon2":
                arr = data.ManikJSon[0].JSon2;
                break;
              case "JSon3":
                arr = data.ManikJSon[0].JSon3;
                break;
              case "JSon4":
                arr = data.ManikJSon[0].JSon4;
                break;
            }
            localStorage.setItem(
              this.DomainName + "_" + item.Entity,
              JSON.stringify(arr)
            );
          });
        }
      });
  }

  SetPortalIdentifierAndApplyTheme(identifier: string, styleUrl: string) {
    let manikLib = new ManikEntityFE();
    sessionStorage.setItem("PortalIdentifier", identifier);
    sessionStorage.setItem("PortalDS", "EMCITY");
    console.log(identifier);
    manikLib.BindCSS(styleUrl);
  }
}
